import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Topup from "../pages/Topup";
import NotFound from "../pages/NotFound";
import SelfRegister from "../pages/SelfRegister";
import Plan from "../pages/Plan";
import Auth from "../pages/Auth";
import Order from "../pages/Order";
import History from "../pages/History";
import PackageDetail from "../pages/PackageDetail";
import Test from "../pages/Test";
import AsADealer from "../pages/AsADealer";
import DealerRegister from "../pages/DealerRegister";
import RegCustomers from "../pages/RegCustomers";
import MNP from "../pages/MNP";
import MNPReg from "../pages/MNPReg";
import MNPForm from "../pages/MNPForm";
import CashBack from "../pages/CashBack";
import MoreDetail from "../pages/MoreDetail";
import ExtendValidity from "../pages/ExtendValidity";
import AddOnPlan from "../pages/AddOnPlan";
import SuccessRegPage from "../pages/SuccessRegPage";
import ReferralList from "../pages/ReferralList";
export default function Routing() {
  return (
    <Routes>
      <Route path="/" element={<Auth />} />
      <Route path="/home" element={<Home />} />
      <Route path="/topup" element={<Topup />} />
      <Route path="/selfregister" element={<SelfRegister />} />
      <Route path="/plan" element={<Plan />} />
      <Route path="/history" element={<History />} />
      <Route path="/order" element={<Order />} />
      <Route path="/package-detail" element={<PackageDetail />} />
      <Route path="/test" element={<Test />} />
      <Route path="/dealer" element={<AsADealer/>} />
      <Route path="/dealer-register" element={<DealerRegister/>} />
      <Route path="/registered-customers" element={<RegCustomers/>} />
      <Route path="/mnp" element={<MNP/>} />
      <Route path="/mnp-register" element={<MNPReg/>} />
      <Route path="/cashback-history" element={<CashBack/>} />
      <Route path="/mnp-register-form" element={<MNPForm/>} />
      <Route path="/extend-validity" element={<ExtendValidity/>} />
      <Route path="/more-detail" element={<MoreDetail/>} />
      <Route path="/add-on-plan" element={<AddOnPlan/>} />
      <Route path="/dealer-register-success" element={<SuccessRegPage/>} />
      <Route path="/referral-list" element={<ReferralList />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
